// src/plugins/vuetify-autogrow-scroll-fix.js
import VTextarea from "vuetify/lib/components/VTextarea/VTextarea";

const original = VTextarea.options.methods.calculateInputHeight;

VTextarea.options.methods.calculateInputHeight = function () {
  const input = this.$refs.input;
  if (!input) return original.call(this);

  // Any scrolled ancestor can get clamped when the textarea collapses to 0.
  const saved = [];
  for (let el = input.parentElement; el; el = el.parentElement) {
    if (el.scrollTop) saved.push([el, el.scrollTop]);
  }
  const doc = document.scrollingElement || document.documentElement;
  const docTop = doc.scrollTop;

  original.call(this);

  for (const [el, top] of saved) {
    if (el.scrollTop !== top) el.scrollTop = top;
  }
  if (doc.scrollTop !== docTop) doc.scrollTop = docTop;
};
